'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildDataSourceUrl = function buildDataSourceUrl(apiRoot, datasourceId, filters) {
  var params = (0, _keys2.default)(filters).map(function (key) {
    return key + '=' + filters[key];
  });
  var url = apiRoot + '/' + datasourceId + '/feed?' + params.join('&');
  return url;
};

exports.default = buildDataSourceUrl;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/utils/buildDataSourceUrl.js
// module id = 1125
// module chunks = 5